import api from "../helpers/api";

class ActivityService {
  async getActivities(params = {}) {
    try {
      const apiParams = {
        ...params, 
        page: params.page || 1,
        per_page: params.perPage || 10,
        search: params.searchQuery || undefined,
        is_approved: params.is_approved !== undefined ? params.is_approved : false,
        status: this.extractStatusValue(params.filterStatus),
      };
      if (params.filterDateRange?.length === 2) {
        apiParams.start_date = this.formatDate(params.filterDateRange[0]);
        apiParams.end_date = this.formatDate(params.filterDateRange[1]);
      }
      //other parameters

      Object.keys(apiParams).forEach(key => 
        apiParams[key] === undefined && delete apiParams[key]
      );
      
      // console.log(params);
      
      const response = await api.get("activities", { params: apiParams });
      
      return response
      // return {
      //   success: true,
      //   data: response.data?.activities?.data || [],
      //   activityStatistics: response.data?.activityStatistics || [],
      //   total: response.data?.activities?.total || 0,
      //   currentPage: response.data?.activities?.current_page || 1,
      //   lastPage: response.data?.activities?.last_page || 1,
      // };
    } catch (error) {
      console.error("ActivityService.getActivities error:", error);
      return {
        success: false,
        data: [],
        total: 0,
        error: this.getErrorMessage(error),
      };
    }
  }

  // get user tasks

  async getActivitiesByUser(userId,params = {}) {
    try {
      const apiParams = {
        ...params,
        page: params.page || 1,
        per_page: params.perPage || 10,
        search: params.searchQuery || undefined,
        is_approved: params.is_approved !== undefined ? params.is_approved : undefined,
        status: this.extractStatusValue(params.filterStatus),
      };
      if (params.filterDateRange?.length === 2) {
        apiParams.start_date = this.formatDate(params.filterDateRange[0]);
        apiParams.end_date = this.formatDate(params.filterDateRange[1]);
      }
      Object.keys(apiParams).forEach(key => 
        apiParams[key] === undefined && delete apiParams[key]
      );
      const response = await api.get(`activities/user/${userId}`, { params: apiParams });
      return response.data;
    } catch (error) {
      console.error("ActivityService.getMyActivities error:", error);
      return {
        success: false,
        data: [],
        total: 0,
        error: this.getErrorMessage(error),
      };
    }
  }
  // get my tastks

  async getMyActivities(params = {}) {
    try {
      const apiParams = {
        ...params,
        page: params.page || 1,
        per_page: params.perPage || 10,
        search: params.searchQuery || undefined,
        is_approved: params.is_approved !== undefined ? params.is_approved : undefined,
        status: this.extractStatusValue(params.filterStatus),
      };
      if (params.filterDateRange?.length === 2) {
        apiParams.start_date = this.formatDate(params.filterDateRange[0]);
        apiParams.end_date = this.formatDate(params.filterDateRange[1]);
      }
      Object.keys(apiParams).forEach(key => 
        apiParams[key] === undefined && delete apiParams[key]
      );
      const response = await api.get("activities/my-activities", { params: apiParams });
      return response.data;
    } catch (error) {
      console.error("ActivityService.getMyActivities error:", error);
      return {
        success: false,
        data: [],
        total: 0,
        error: this.getErrorMessage(error),
      };
    }
  }

  // Helper methods
  extractStatusValue(statusFilter) {
    if (!statusFilter) return undefined;
    return statusFilter.value === 'All' ? undefined : statusFilter.value;
  }

  formatDate(date) {
    if (!date) return undefined;
    return new Date(date).toISOString().split('T')[0]; // YYYY-MM-DD
  }

  getErrorMessage(error) {
    if (error.response) {
      return error.response.data?.message || 
             error.response.statusText || 
             'API request failed';
    }
    return error.message || 'Network error';
  }
  // formatAPIDate(date) {
  //   if (!date) return undefined;
  //   return dayjs(date).format('YYYY-MM-DD');
  // }
  async createActivity(payload) {
    return await api.post("activity", payload);
  }

  async submitForApproval(id) {
    return await api.post(`activities/${id}/approval/submit`);
  }

  async approveMe(id, approvalData) {
    return await api.post(`activities/${id}/approval/me/approve`, approvalData);
  }

  async approveFinance(id, approvalData) {
    return await api.post(`activities/${id}/approval/finance/approve`, approvalData);
  }

  async approveCeo(id, approvalData) {
    return await api.post(`activities/${id}/approval/ceo/approve`, approvalData);
  }



  async approveActivity(id, role, approvalData) {
    return await api.post(`activities/${id}/approval/${role}/approve`, approvalData);
  }

  async rejectActivity(id,  rejectionData) {
    return await api.post(`activities/${id}/approval/reject`, rejectionData);
  }

  async requestChanges(id, changesData) {
    return await api.post(`activities/${id}/approval/request-changes`, changesData);
  }

  async awaitingMyApproval(params) {
    return await api.get(`/activities/awaiting-my-approval`, { params });
  }
  async getActivityApprovalStatus(id) {
    return await api.get(`activities/${id}/approval/status`);
  }

  async getActivityById(id) {
    return await api.get(`activity/${id}`);
  }

  async updateActivity(id, payload) {
    return await api.put(`activity/${id}`, payload);
  }

  async updateActivityStatus(id, status) {

    //pass status as parameter
    return await api.put(`activity/${id}/status`, { status:status });
  }

  async deleteActivity(id) {
    return await api.delete(`activity/${id}`);
  }

  async restoreActivity(id) {
    return await api.put(`activity/${id}/restore`);
  }

  async assignUser(id, userId) {
    return await api.post(`/activity/${id}/assign-user`, { user_id: userId });
  }

  async unassignUser(id) {
    return await api.post(`/activity/${id}/unassign-user`);
  }

  async getAssignee(id) {
    const res = await api.get(`/activity/${id}/assignee`);
    return res.data;
  }

  async getActivityStat(){
    return await api.get("activity/statistics");
  }

  submitReport(activityId, data) {
    return api.post(`/activity/${activityId}/report`, data);
  }
}

export default new ActivityService();
